const SUB_ACCOUNT_PAYOUT_STATUSES = [
  "PENDING",
  "PROCESSING",
  "PAID",
  "AWAITING_MANUAL",
];

export default SUB_ACCOUNT_PAYOUT_STATUSES;
